import Vue from 'vue';
import Router from 'vue-router';
import AuthRoutes from './routing/authRoute';
import PanelRoutes from './routing/PanelRoute';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    ...AuthRoutes,
    ...PanelRoutes,
  ],
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public);
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut);
  const loggedIn = !!localStorage.getItem('TOKEN');
  if (to.fullPath === '/panel') {
    next('panel/vouchers');
  } else if (to.fullPath === '/') {
    next('login');
  } else {
    next();
  }
  if (!isPublic && !loggedIn) {
    return next({
      path: '/login',
      query: {redirect: to.fullPath},
    });
  }

  if (loggedIn && onlyWhenLoggedOut) {
    return next('/panel/vouchers');
  }
  next();
  return 0;
});

export default router;
